var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { xs: 20, sm: 9, md: 7, lg: 6, xl: 4 } },
            [
              _c("registry-admin-menu", {
                on: { addUniversity: _vm.addUniversityEvent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 16, lg: 16, xl: 16 } },
            [
              _c("search-uni", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchUniVisible,
                    expression: "searchUniVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _vm.addUniversity
                ? _c("manage-db", {
                    attrs: { addUniversity: _vm.addUniversity },
                    on: { hideForm: _vm.hideForm }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05139632", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05139632","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegistryAdmin.vue
// module id = null
// module chunks = 